<template>
	<section>
		<div>
			<b-table class="item-table" :data="itemList">
				<template slot-scope="props">
					<b-table-column sortable :label="$t('ID')">{{ props.row.id }}</b-table-column>
					<b-table-column sortable :label="$t('SKU')">{{ props.row.Bid.Product.sku }}</b-table-column>
					<b-table-column sortable :label="$t('Product name')">{{ props.row.Bid.Product.name }}</b-table-column>
					<b-table-column sortable :label="$t('Status')">{{ $t(props.row.status_text) }}</b-table-column>
					<b-table-column field="price" :label="$t('Price (with commission)')">{{
						toCurr(props.row.Bid.price_with_commission)
					}}</b-table-column>					
				</template>
				<template slot="empty">
					<h3 class="title">{{ $t('No results…') }}</h3>
				</template>
			</b-table>
		</div>
	</section>
</template>
<script>
export default {
	data() {
		return {
			currency: localStorage.getItem('currency') || 'HUF',
			itemList: [],
		}
	},
	props: {
		order_id: {
			required: true,
		},
		status: {
			required: true,
		},
	},

	methods: {
		toCurr(val, currency) {
			return this.$options.filters.toUserCurrency(val, this, currency)
		},
		getBids() {
			var _this = this
			_this.$http.get('/order/items/payed/' + this.order_id).then((response) => {
				console.log('Bids:', response.data.order_bid)
				_this.itemList = response.data.order_bid
				_this.loading = false
			})
		},
	},
	mounted() {
		this.getBids()
	},
}
</script>
<style scoped>
.item-table >>> .table {
	background-color: #fafafa !important;
}
</style>
